// src-dev/ts/components/hero-slider.ts

const INTERVAL_MS = 5000;

export class HeroSlider {
  private slides: NodeListOf<HTMLElement>;
  private current: number = 0;
  private timer: ReturnType<typeof setInterval> | null = null;

  constructor(selector: string) {
    const hero = document.querySelector<HTMLElement>(selector);
    if (!hero) throw new Error(`HeroSlider: no se encontró "${selector}"`);

    this.slides = hero.querySelectorAll<HTMLElement>('.hero-slide');

    hero.querySelector('.prev')?.addEventListener('click', () => this.move(-1));
    hero.querySelector('.next')?.addEventListener('click', () => this.move(1));

    this.startAuto();
  }

  private setSlide(index: number): void {
    this.slides[this.current].classList.remove('active');
    this.current = (index + this.slides.length) % this.slides.length;
    this.slides[this.current].classList.add('active');
  }

  move(direction: 1 | -1): void {
    this.setSlide(this.current + direction);
    this.resetAuto();
  }

  private startAuto(): void {
    this.timer = setInterval(() => this.move(1), INTERVAL_MS);
  }

  private resetAuto(): void {
    if (this.timer) clearInterval(this.timer);
    this.startAuto();
  }
}

export function initHeroSlider(): void {
  new HeroSlider('#section-hero');
}